import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
// import { OwlOptions } from 'ngx-owl-carousel-o';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomValidators } from 'ng2-validation';
import { AuthService } from 'src/app/services/auth.service';
import { MustMatch } from 'src/app/_helpers/must-match.validator';
import { TokenStorageService } from '../../services/token-storage.service';
import { RoleService } from 'src/app/services/role.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { maxYearFunction } from 'src/app/_helpers/utility';
import { HeaderComponent } from '../header/header.component';
import { CityService } from 'src/app/manage/city/service/city.service';
import { UserService } from 'src/app/services/user.service';
import { CountryService } from 'src/app/manage/country/service/country.service';
import { StateService } from 'src/app/manage/state/service/state.service';
import { BannerService } from 'src/app/services/banner.service';
import { CategoryService } from 'src/app/services/category.service';
import * as moment from 'moment';
import { Subscription, timer } from 'rxjs';
import { take } from 'rxjs/operators';
@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  providers: [ConfirmationService, MessageService, HeaderComponent],
})
export class SignInComponent implements OnInit {
  public totalRecords;
  public bannerList: any = [];
  signUpForm: FormGroup;
  loginForm: FormGroup;
  forgotPassForm: FormGroup;
  mobileLoginForm: FormGroup;
  submitted: boolean = false;
  loginFormSubmitted: boolean = false;
  genders;
  message;
  showMessage: boolean = false;
  selectedGender: any = null;
  userType;
  userData;
  isLoginFailed: boolean;
  isLoggedIn: boolean;
  roles;
  trainerRoleId;
  permissions: any[] = [];
  permissionArray: any[] = [];
  userTypeListArray: any[] = [];
  rolelist: any[] = [];
  errorMessage;;
  ipAddress;
  yearRange;
  minDateValue: Date;
  minYear = environment.minYear;
  showGenderError;
  public cityList: any[] = [];
  public selectedCityId;
  public selectedCityName;
  public mobileNumber;
  public showOtpForm: boolean = false;
  public successMessage;
  public activeIndex: number = 0;
  public showCategoryError: boolean = false;
  public countDown: Subscription;
  public counter;
  public tick;
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  public config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    required: true,
    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px'
    }
  };
  public otp: string;
  public showForgotPasswordForm: boolean = false;
  public showOtpErrors: boolean = false;
  public showOtpErrorsMsg: boolean = false;
  public showMobileLoginOtpForm: boolean = false;
  public showResendButton: boolean = false;
  public showMobileFormErrors: boolean = false;
  public mobileFormsErrors: boolean = false;
  public otpLoginErrors: boolean = false;
  public showOtpLoginErrors: boolean = false;
  public loading: boolean = false;
  public otpErrorMessage;
  public displayTime;
  public loggedInUser;
  public userCategories: any[] = [];
  public countrylist: any[] = [];
  public selectedCategory = undefined;
  public stateList: any[] = [];
  public countryName;
  public countryCode;
  public stateName;
  public stateCode;
  public cityName;
  public cityCode;
  public bannerImageList: any = [];
  parentcatList: any[] = [];
  public defaultDate: Date = new Date(environment.defaultDate);
  //@ViewChild('headerComponent', { static: false }) refreshChild: HeaderComponent;
  constructor(private categoryService: CategoryService, private router: Router, private formBuilder: FormBuilder, private roleService: RoleService, private http: HttpClient, private headerComponent: HeaderComponent,
    private cd: ChangeDetectorRef, private cityService: CityService, private userService: UserService, private countryService: CountryService, private stateService: StateService,
    private tokenStorage: TokenStorageService, private bannerService: BannerService, private authService: AuthService, private messageService: MessageService, private confirmationService: ConfirmationService) {

  }
  ngOnInit(): void {
    this.getBanner();
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.isLoggedIn = true;
      let currentUrl = '/';
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
    }
    this.userCategories = environment.userCategories;
    this.minDateValue = new Date();
    this.yearRange = this.minYear + ":" + maxYearFunction();
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, CustomValidators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      rememberMe: [true],
    });
    this.signUpForm = this.formBuilder.group({
      firstName: ['', {
        validators: [Validators.required, Validators.pattern('[A-Za-z][A-Za-z]*$')], updateOn: 'blur'
      }],
      lastName: ['', {
        validators: [Validators.required, Validators.pattern('[A-Za-z][A-Za-z]*$')], updateOn: 'blur'
      }],
      email: ['', {
        validators: [Validators.required, Validators.email, CustomValidators.email], updateOn: 'blur'
      }],
      password: ['', {
        validators: [Validators.required, Validators.pattern("^(?=[^A-Z\n]*[A-Z])(?=[^a-z\n]*[a-z])(?=[^0-9\n]*[0-9])(?=[^#?!@$%^&*\n-]*[#?!@$%^&*-]).{6,}$")], updateOn: 'blur'
      }],
      confirmPassword: ['', {
        validators: Validators.required, updateOn: 'blur'
      }],
      mobileNumber: [null, {
        validators: [Validators.required, Validators.pattern("[0-9 ]{10}")], updateOn: 'blur'
      }],
      country: ['', {
        validators: [Validators.required], updateOn: 'blur'
      }],
      state: ['', {
        validators: [Validators.required], updateOn: 'blur'
      }],
      city: ['', {
        validators: [Validators.required], updateOn: 'blur'
      }],
      gender: [''],
      dob: ['', {
        validators: [Validators.required]
      }],
      referral: ['']
      //role: ['player'],
      //userType: ['player']
    }, {
      validator: MustMatch('password', 'confirmPassword'),
      //updateOn: "blur" 
    });

    this.userCategories.forEach(element => {
      this.signUpForm.addControl(element.slug, new FormControl());
      if (element.slug == "player") {
        this.selectedCategory = element.slug;
        this.signUpForm.get(element.slug).setValue(element.status);
      }
    });
    this.forgotPassForm = new FormGroup({
      email: new FormControl("", [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}")])
    });
    this.mobileLoginForm = this.formBuilder.group({
      mobileNumber: [, [Validators.required, Validators.pattern("[0-9 ]{10}")]],
    });
    this.genders = [
      { id: '1', name: 'Male', code: 'Male' },
      { id: '2', name: 'Female', code: 'Female' },
      { id: '3', name: 'Other', code: 'Other' },
    ];
    this.selectedGender = this.genders[0];
    if (this.isLoggedIn == true) {
      this.getCountries();
    }
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.signUpForm.controls;
  }
  get loginf() {
    return this.loginForm.controls;
  }
  get forgotPassValidation() {
    return this.forgotPassForm.controls;
  }
  get mobNumberFormValidation() {
    return this.mobileLoginForm.controls;
  }
  onGenderSelect(event) {
    this.selectedGender = '';
    if (event.value) {
      this.selectedGender = event.value.code;
    }
  }
  onCitySelect(event) {
    this.selectedCityId = undefined;
    this.selectedCityName = undefined;
    if (event.value) {
      this.selectedCityId = event.value.id;
      this.selectedCityName = event.value.name;
    }
  }
  onClickForgotPassword() {
    this.showForgotPasswordForm = true;
  }
  getCountries() {
    let query = "filterByDisable=false&filterByStatus=true";
    this.countryService.getcountryList(query).subscribe(
      data => {
        if (data.data.items.length > 0) {
          data.data.items.forEach(element => {
            let countryObj = {
              name: element.name,
              iso2: element.iso2,
            }
            this.countrylist.push(countryObj);
          });
          this.countryName = "India";
          this.countryCode = "IN";
          this.signUpForm.controls.country.setValue({ name: this.countryName, iso2: this.countryCode });
          this.getStates(false, this.countryCode);
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
  getStates(fromForm, event) {
    this.stateList = [];
    this.stateCode = '';
    this.stateName = '';
    this.cityList = [];
    this.cityCode = '';
    this.cityName = '';
    if (fromForm == true) {
      //this.signUpForm.get('zipcode').reset();
      this.countryCode = event.value.iso2;
      this.countryName = event.value.name;
    } else {
      this.countryCode = event;
    }

    // this.countryName = event.value.name;
    // this.countryCode = event.value.iso2;
    let query = "filterByDisable=false&orderBy=name&sortBy=1&filterByCountryCode=" + this.countryCode;
    this.stateService.getstateList(query).subscribe((res) => {
      if (res.data.items.length > 0) {
        res.data.items.forEach(element => {
          let stateObj = {
            name: element.name,
            id: element.id,
          }
          this.stateList.push(stateObj);
        });
      }
    })
  }
  setState(event) {
    this.stateCode = event.value.id;
    this.stateName = event.value.name;
    this.getCities(this.stateCode);
  }
  getCities(stateId) {
    this.cityList = [];
    this.cityCode = '';
    this.cityName = '';
    let query = "?filterByStatus=true&filterByDisable=false&orderBy=name&sortBy=1&filterByStateId=" + stateId;
    this.cityService.getcityList(query).subscribe((res) => {
      if (res.data.items.length > 0) {
        res.data.items.forEach(element => {
          let cityObj = {
            name: element.name,
            code: element.name,
          }
          this.cityList.push(cityObj);
        });
      }
    })
  }
  // onCitySelect(event) {
  //   this.cityCode = event.value.code;
  //   this.cityName = event.value.name;
  // }
  getRoleDetails() {
    const querystring = "filterByroleId=" + this.userData.data.userdata.role;
    this.roleService.getRoleListWithoutAuth(querystring).subscribe(
      data => {
        this.trainerRoleId = data.data.items[0]['id'];
        this.permissions = data.data.items[0]['permissions'];
        this.tokenStorage.saveUserPermissions(this.permissions);
        this.rolelist = data.data.items[0];
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
  findIndexByIdArray(name, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].rolename === name) {
        index = i;
        break;
      }
    }
    return index;
  }
  getRoleList() {
    var querystring = "filterByDisable=false&filterByStatus=true";
    var rolearray = [];
    this.roleService.getRoleListWithoutAuth(querystring).subscribe(
      data => {
        var rolelist = data.data.items;
        rolelist.forEach(element => {
          rolearray.push({ "roleid": element.id, "rolename": element.user_role_name });
        });
        if (rolearray.length > 0) {
          this.tokenStorage.saveRolelist(rolearray);
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
  onUserCategorySelect(userCategory, event) {
    this.selectedCategory = undefined;
    if (event.isTrusted) {
      this.selectedCategory = userCategory.slug;
      this.userCategories.forEach(element => {
        let obj = { slug: element.slug, name: element.name, status: element.status };
        if (this.selectedCategory == element.slug) {
          const index = this.findIndexBySlug(element.slug, this.userCategories);
          obj = { slug: element.slug, name: element.name, status: true };
          this.userCategories[index] = obj;
          this.signUpForm.get(element.slug).setValue(obj.status);
        } else {
          const index = this.findIndexBySlug(element.slug, this.userCategories);
          obj = { slug: element.slug, name: element.name, status: false };
          this.userCategories[index] = obj;
          //this.accountReportForm.get(element.name).setValue(reportObj);
        }
      })
    }
  }
  findIndexBySlug(slug, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].slug === slug) {
        index = i;
        break;
      }
    }
    return index;
  }
  onSubmit(): void {
    this.loginFormSubmitted = true;
    //stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }
    const username = this.loginForm.value.email;
    const password = this.loginForm.value.password;
    const rememberMeValue = this.loginForm.value.rememberMe;
    this.userType = "player";

    this.authService.login(username, password, this.userType, rememberMeValue).subscribe(
      data => {
        this.userData = data;
        this.userData.data.rememberMe = rememberMeValue;
        this.tokenStorage.saveToken(this.userData.data.access_token);
        this.tokenStorage.saveUser(this.userData.data);
        this.tokenStorage.getAuthStatus(this.userData.data);
        this.isLoginFailed = false;
        this.isLoggedIn = true;
        this.roles = this.tokenStorage.getUser().roles;
        this.getRoleDetails();
        this.getRoleList();
        this.getParentCategory();
        let academyPaymentDetails = this.userData.data.userdata.academyPaymentDetails;
        let roleName = this.userData.data.userdata.rolename;
        let isFromReferAndEarn = window.sessionStorage.getItem('isFromReferAndEarn');
        if (isFromReferAndEarn === 'true') {
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigateByUrl('refer-earn');
          return;
        }
        let currentUrl = '/';
        if (roleName == "academy") {
          if (Object.keys(academyPaymentDetails).length > 0) {
            if (academyPaymentDetails.academyPaymentStatus == 'created') {
              currentUrl = '/payment-history';
            } else {
              currentUrl = '/academies-profile';
            }
          } else {
            currentUrl = '/payment-history';
          }
        } else {
          if (this.userData.data.userdata.isProfileComplete === false) {
            currentUrl = '/profile-edit';
          }
        }

        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
      },
      error => {
        //throw Error();
        this.loginFormSubmitted = false;
        this.errorMessage = 'Login failed: Please check your login credentials...! ';
        // let currentUrl = '/sign-in';
        // // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        // // this.router.onSameUrlNavigation = 'reload';
        // // this.router.navigate([currentUrl]);
        this.isLoginFailed = true;
      }
    );
    //});
  }
  getParentCategory() {
    var query = "?filterByDisable=false&filterByStatus=true&getOnlyParent=true";
    this.categoryService.getCategoryList(query).subscribe(
      data => {
        this.parentcatList = data.data.items;
        this.tokenStorage.saveCategorylist(this.parentcatList);
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
  onSignupSubmit(): void {
    this.submitted = true;
    //stop here if form is invalid
    if (this.signUpForm.invalid) {
      return;
    }
    let userData = this.signUpForm.value;
    if (this.selectedGender == null) {
      this.showGenderError = true;
      return;
    }
    if (this.selectedCategory == undefined) {
      this.showCategoryError = true;
      return;
    }
    userData['gender'] = this.selectedGender;
    userData['countryname'] = this.countryName;
    userData['countrycode'] = this.countryCode;
    userData['statename'] = this.stateName;
    userData['statecode'] = this.stateCode;
    userData['citycode'] = this.selectedCityId;
    userData['cityname'] = this.selectedCityName;
    userData['role'] = this.selectedCategory;
    userData['userType'] = this.selectedCategory;
    this.mobileNumber = userData['mobileNumber'];
    delete userData['coach'];
    delete userData['player'];
    delete userData['country'];
    delete userData['state'];
    delete userData['city'];
    this.authService.playerSignup(userData).subscribe(
      data => {
        //this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'User Added', life: 6000 });
        // setTimeout(() => {
        this.showMessage = true;
        this.showOtpForm = true;
        this.submitted = false;
        //this.message = 'User Added';
        setTimeout(() => {
          this.showMessage = false;
        }, 5000);
        this.signUpForm.reset();
        // this.userTypeError = false;
        //this.selectedGender = this.genders[0];
        //this.router.navigateByUrl("/sign-in");
        //}, 5000);
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: err.error.error, life: 6000 });
        // this.showMessage = true;
        // this.message = err.error.error;
        // setTimeout(() => {
        //   this.showMessage = false;
        // }, 5000);
        //this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add User Failed', life: 6000 });
      })
    );
  }
  onOtpChange(otp) {
    this.otp = otp;
    this.showMobileFormErrors = false;
    this.showOtpErrors = false;
    this.showOtpLoginErrors = false;
  }
  onClickOtpSubmit() {
    if (this.otp == undefined || this.otp.length < 6) {
      this.showOtpErrors = true;
      return;
    }
    let otpData = {
      'otp': this.otp,
      'mobileNumber': this.mobileNumber,
    }
    this.authService.verifyOtp(otpData).subscribe(
      data => {

        // setTimeout(() => {
        // this.showMessage = true;
        // this.signUpForm.reset();
        // this.submitted = false;
        // this.showOtpForm = false;
        // this.showOtpErrors = false;
        // this.activeIndex = Number(0);
        // this.successMessage = 'Otp verified Successfully! Please login';
        // setTimeout(() => {
        //   this.showMessage = false;
        // }, 5000);
        this.router.navigate(['/thankyou']);
      },
      ((err) => {
        this.showOtpErrorsMsg = true;
        this.otpErrorMessage = err.error.error;
        setTimeout(() => {
          this.showOtpErrorsMsg = false;

        }, 5000);

      })
    );
  }
  onForgotPassSubmit() {
    this.submitted = true;
    if (this.forgotPassForm.valid) {
      this.authService.requestPassword(this.forgotPassForm.value).subscribe(res => {
        if (res['errors']) {
          this.errorMessage = res['errors'];
          this.successMessage = '';
        } else {
          this.successMessage = res;
          this.errorMessage = '';
        }
        this.showMessage = true;
        setTimeout(() => {
          this.submitted = false;
          this.forgotPassForm.reset();
          this.showMessage = false;
          this.successMessage = '';
        }, 2000);
      },
        err => {
          this.successMessage = '';
          this.showMessage = true;
          this.errorMessage = err.error.data.errors;
        });
    }
  }
  onMobilePhoneSubmit(mode) {
    let mobileData;
    if (mode != "resend") {
      this.submitted = true;
      //stop here if form is invalid
      if (this.mobileLoginForm.invalid) {
        return;
      }

      mobileData = this.mobileLoginForm.value.mobileNumber;
      this.mobileNumber = mobileData;
    } else {
      mobileData = this.mobileNumber
    }

    this.authService.generateMobileOtp(mobileData).subscribe(
      res => {

        this.showMobileLoginOtpForm = true;
        this.showResendButton = false;
        //this.timer(5);
        this.counter = 300;
        this.tick = 1000;
        this.otpTimer(this.counter, this.tick);
      }, err => {
        this.showMobileFormErrors = true;
        this.mobileFormsErrors = err.error.error;
        setTimeout(() => {
          this.showMobileFormErrors = false;
        }, 5000);
        this.showMobileLoginOtpForm = false;
      });
  }

  onClickOtpback() {
    this.showMobileLoginOtpForm = false;
    this.showMobileFormErrors = false;
    this.showOtpErrors = false;
    this.showOtpLoginErrors = false;
    this.countDown.unsubscribe();
  }
  resendOtp() {
    let mode = 'resend';
    this.showMobileFormErrors = false;
    this.showOtpErrors = false;
    this.showOtpLoginErrors = false;
    this.otp = '';
    this.ngOtpInput.setValue(0);
    this.onMobilePhoneSubmit(mode);
  }
  onClickOtpLoginSubmit() {
    if (this.otp == undefined || this.otp == '' || this.otp.length < 6) {
      this.showOtpErrors = true;
      this.showOtpLoginErrors = false;
      return;
    }
    let otpData = {
      'otp': this.otp,
      'mobileNumber': this.mobileNumber,
    }
    this.authService.otpLogin(otpData).subscribe(
      data => {
        this.userData = data;

        // this.tokenStorage.saveToken(this.userData.data.access_token);
        // this.tokenStorage.saveUser(this.userData.data);
        // this.tokenStorage.getAuthStatus(this.userData.data);
        // this.isLoggedIn = true;
        // this.roles = this.tokenStorage.getUser().roles;
        // this.getRoleDetails();
        // this.getRoleList();
        // let currentUrl = '/';
        // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        // this.router.onSameUrlNavigation = 'reload';
        // this.router.navigate([currentUrl]);
        this.userData = data;
        this.tokenStorage.saveToken(this.userData.data.access_token);
        this.tokenStorage.saveUser(this.userData.data);
        this.tokenStorage.getAuthStatus(this.userData.data);
        this.isLoginFailed = false;
        this.isLoggedIn = true;
        this.roles = this.tokenStorage.getUser().roles;
        this.getRoleDetails();
        this.getRoleList();
        this.getParentCategory();
        let academyPaymentDetails = this.userData.data.userdata.academyPaymentDetails;
        let roleName = this.userData.data.userdata.rolename;
        let currentUrl = '/';
        if (roleName == "academy") {
          if (Object.keys(academyPaymentDetails).length > 0) {
            if (academyPaymentDetails.academyPaymentStatus == 'created') {
              currentUrl = '/payment-history';
            } else {
              currentUrl = '/academies-profile';
            }
          } else {
            currentUrl = '/payment-history';
          }
        }
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
      },
      ((err) => {
        console.log(err, 'error')
        this.showOtpLoginErrors = true;
        this.otpLoginErrors = err.error.error;


      })
    );
  }
  timer(minute) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;

    const prefix = minute < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.displayTime = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        clearInterval(timer);
        this.showResendButton = true;
      }
    }, 1000);
    if (minute == 0) {
      this.displayTime = 0;
      clearInterval(timer);
    }
  }
  otpTimer(counter, tick) {
    this.countDown = timer(0, this.tick)
      .pipe(take(this.counter))
      .subscribe(() => {
        --this.counter;
        if (this.counter == 0) {
          this.showResendButton = true;
          this.countDown.unsubscribe();
        }
      });
  }
  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return (
      ('00' + minutes).slice(-2) +
      ':' +
      ('00' + Math.floor(value - minutes * 60)).slice(-2)
    );
  }
  getBanner() {
    let query = "?filterByDisable=false&filterByStatus=true&filterBySlug=login";
    this.bannerService.getbannerList(query).subscribe(
      data => {
        this.loading = false;
        this.bannerList = data.data.items;
        this.totalRecords = data.data.totalCount;
        this.bannerList.forEach(element => {
          this.bannerImageList = element.banner_image;
        });
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  onForgotPassBack() {
    this.showForgotPasswordForm = false;
  }
  // reset() {
  //   this.submitted = false;
  // }
}
